import { Component, OnDestroy, OnInit } from '@angular/core';
import { convertDesignIdToCommunicationId, trackByRef } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DesignService, ElementRiskAssessmentService } from 'src/app/state';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'em-element-risk-assessment',
  templateUrl: './element-risk-assessment.component.html',
  standalone: false,
})
export class ElementRiskAssessmentComponent implements OnInit, OnDestroy {
  public elementRiskAssessments$ = this.elementRiskAssessmentService.elementRiskAssessments$;
  public isLoading$ = this.elementRiskAssessmentService.loading$;
  public error$ = this.elementRiskAssessmentService.error$;
  public isDesignLoading$ = this.designService.loading$;
  public readonly trackByRef = trackByRef;
  public siteUrl = environment.sharePointERASiteUrl;

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly designService: DesignService,
    private readonly elementRiskAssessmentService: ElementRiskAssessmentService
  ) {}

  public ngOnInit() {
    this.subscriptions.add(
      this.designService.designId$
        .pipe(
          map(convertDesignIdToCommunicationId),
          switchMap((communicationId) =>
            this.elementRiskAssessmentService.loadByCommunicationId(communicationId)
          )
        )
        .subscribe()
    );
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
